var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#000",
    transform: "rotate(-180 20 20)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M.5 18c0-4.832 1.959-9.207 5.126-12.374C8.793 2.459 13.168.5 18 .5c4.832 0 9.207 1.959 12.374 5.126C33.541 8.793 35.5 13.168 35.5 18c0 4.832-1.959 9.207-5.126 12.374C27.207 33.541 22.832 35.5 18 35.5c-6.26 0-11.75-3.286-14.844-8.227C1.473 24.584.5 21.406.5 18z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.253 23.245c2.36.364 4.174.058 5.443-.917 5.055-3.885 7.696-5.968 11.293-5.968 3.528 0 6.902 2.18 11.701 5.968 1.063.839 2.584 1.144 4.563.917-1.7 4.388-3.221 7.063-4.563 8.026-4.103 2.946-9.22 4.089-11.695 4.089-2.427 0-7.58-1.258-11.3-4.089-1.29-.982-3.104-3.657-5.442-8.026z",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.cf9f550ace3e54e0a6ec843ac0e9a10c.svg";
export { ForwardRef as ReactComponent };